import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {PaymentScheduleSearchFilterData} from "../types/PaymentScheduleSearchFilterData";

export const useGetPaymentScheduleFilterData = () => {
	const { data, isLoading } = useQuery({
		queryKey: ['payment-schedule-filters'],
		queryFn: async () => await apiClient.get('payment-schedule/filter-data') as PaymentScheduleSearchFilterData
	});

	return {
		data,
		isLoading
	};
};
